/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Brand_Kit_TakenInputs */

const en_error_brand_kit_taken = /** @type {(inputs: Error_Brand_Kit_TakenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This brand has its kit already.`)
};

/**
* | output |
* | --- |
* | "This brand has its kit already." |
*
* @param {Error_Brand_Kit_TakenInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_brand_kit_taken = /** @type {((inputs?: Error_Brand_Kit_TakenInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Brand_Kit_TakenInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_brand_kit_taken(inputs)
});